const KEY_PREFIX = "stockBarchartLastRefresh";

export function barchartRefreshStorageKey(accountId, userId) {
  return `${KEY_PREFIX}:${accountId || ""}:${userId || ""}`;
}

export function readBarchartLastRefreshAt(accountId, userId) {
  try {
    const raw = localStorage.getItem(barchartRefreshStorageKey(accountId, userId));
    if (!raw) return null;
    const t = new Date(raw).getTime();
    return Number.isFinite(t) ? raw : null;
  } catch {
    return null;
  }
}

export function writeBarchartLastRefreshAt(accountId, userId, isoOrDate) {
  if (!isoOrDate) return;
  try {
    localStorage.setItem(barchartRefreshStorageKey(accountId, userId), String(isoOrDate));
  } catch {
    /* ignore quota / private mode */
  }
}
